import Flickity from 'flickity-imagesloaded';

export default class Carousel {
    constructor() {
        this.initFlickity();
    }

    initFlickity() {
        const carousel = document.querySelector('.carousel');
        const slider = document.querySelectorAll('.cell');

        if (carousel) {
            let options = {
                draggable: false,
                cellAlign: 'left',
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true,
                lazyLoad: true
            }
            if (window.matchMedia('(max-width: 800px)').matches) {
                options.draggable = true;
                // options.prevNextButtons = false;
                options.friction = 0.8;
                options.selectedAttraction = 0.2;

                document.querySelectorAll('.flickity-buttons').forEach(element => {
                    element.remove();
                });
            } else if (slider.length > 4) {
                // previous
                document.querySelector('.previous-button').addEventListener('click', () => {
                    this.slider.previous();
                });

                // next
                document.querySelector('.next-button').addEventListener('click', () => {
                    this.slider.next();
                });
            }

            if (slider.length <= 4) {
                // options.prevNextButtons = false;
                document.querySelectorAll('.flickity-buttons').forEach(element => {
                    element.remove();
                });
            }

            this.slider = new Flickity(carousel, options);

            carousel.style.opacity = 1;
        }
    }
}
